import { jsx } from 'react/jsx-runtime';
import { useCallback, useMemo } from 'react';
import { styled } from 'styled-components';
import '../../../../../constants/modelCompareData/assets/arrow-right.svg.mjs';
import { useModelCompareTranslation } from '../../../../../constants/modelCompareData/translations/useModelCompareTranslation.mjs';
import { imageSrc } from '../../../../../utils/asset.mjs';
import '../../../../StyleableSvgImage/index.mjs';
import { useStickyGrid } from './StickyGrid/context.mjs';
import arrowRightIcon__default from "../../../../../assets/arrowRight.svg";
import { StyleableSvgImage } from '../../../../StyleableSvgImage/StyleableSvgImage.mjs';
"use strict";
const icon = imageSrc(arrowRightIcon__default);
function ModelCompareOverflowScrollButton({
  isVisible,
  color,
  rotationDegrees,
  onClickColumnDiff,
  totalColumns,
  totalDeadSpace,
  isSmallScreen,
  isLeftButton = true
}) {
  const {
    scrollGroupItemsRef,
    scrollTo
  } = useStickyGrid();
  const {
    formatMessage
  } = useModelCompareTranslation();
  const handleClick = useCallback(() => {
    const anyScrollItem = scrollGroupItemsRef.current?.[0]?.refObject.current;
    if (!anyScrollItem) {
      return;
    }
    const totalWidth = anyScrollItem.scrollWidth;
    const currentScrollLeft = anyScrollItem.scrollLeft + 1;
    const oneColumnWidth = (totalWidth - totalDeadSpace) / totalColumns;
    const currentColumnIndex = Math.min(totalColumns - 1, Math.max(0, Math.round(currentScrollLeft / oneColumnWidth)));
    const newColumnIndex = Math.max(Math.min(currentColumnIndex + onClickColumnDiff, totalColumns), 0);
    const offsetLeft = newColumnIndex * oneColumnWidth;
    scrollTo({
      left: offsetLeft,
      behavior: "smooth"
    });
  }, [onClickColumnDiff, scrollGroupItemsRef, scrollTo, totalColumns, totalDeadSpace]);
  const arrowOffset = useMemo(() => {
    if (isSmallScreen) {
      return rotationDegrees < 180 ? -5 : 0;
    }
    return -15;
  }, [isSmallScreen, rotationDegrees]);
  return /* @__PURE__ */jsx(Button, {
    "aria-label": isLeftButton ? formatMessage("commons.scrollButton.left") : formatMessage("commons.scrollButton.right"),
    $color: color,
    $rotation: rotationDegrees,
    $isVisible: isVisible,
    type: "button",
    onClick: handleClick,
    children: /* @__PURE__ */jsx(Icon, {
      $rotation: rotationDegrees,
      $arrowOffset: arrowOffset,
      children: /* @__PURE__ */jsx(StyleableSvgImage, {
        width: 10,
        height: 16,
        src: icon
      })
    })
  });
}
const Button = styled.button`
  color: inherit;
  outline: none;
  opacity: ${({
  $isVisible
}) => $isVisible ? 1 : 0};
  pointer-events: ${({
  $isVisible
}) => $isVisible ? "auto" : "none"};
  transition: opacity 0.2s;
  height: 100%;
  width: 40px;
  background: transparent;
  border: none;
  background-image: linear-gradient(
    ${({
  $rotation
}) => $rotation - 90}deg,
    ${({
  $color
}) => $color},
    transparent 20px
  );
  border-left: ${({
  $color
}) => $color !== "white" ? "1px solid #eee" : "none"};
  cursor: pointer;
`;
const Icon = styled.div`
  transform: rotate(${({
  $rotation
}) => $rotation}deg)
    translateX(${({
  $arrowOffset
}) => $arrowOffset ?? 0}px);
  display: flex;
  align-items: center;
  justify-content: center;

  padding-left: 4px;
  height: 44px;
  width: 44px;

  border-radius: 50%;
  background: rgb(255 255 255 / 0.8);
  box-shadow: 0 0 10px 0 rgb(0 0 0 / 0.25);
  backdrop-filter: blur(2px);
  color: #808893;
`;
export { ModelCompareOverflowScrollButton };
//# sourceMappingURL=CompareTableOverflowScrollButton.mjs.map
